
export default {
  props: {
    exhibitor: { type: Object, required: true },
  },

  data: () => ({
    bevel: 16,
  }),

  computed: {
    country () {
      const country = this.exhibitor.companyCountry
      return this.$t("geo.countries")[country] || country
    },

    title () {
      const { exhibitor } = this
      if (!exhibitor) return ""
      const { companyCountry, projectName, companyName } = exhibitor
      const name = companyCountry === "RU"
        ? this.$fmt.localize(projectName)
        : projectName.en
      return name || companyName
    },
  },

  methods: {
    toggleLike () {
      if (!this.$auth.loggedIn)
        return this.$router.push(this.localePath("/login"))
      this.$emit("toggle-favorite")
    },
  },
}
